import React from 'react';

const ImageAdRenderer = ({ decision, onRenderState, onFailure }) => {
  const { payload, dimensions } = decision;
  const style = dimensions ? { width: dimensions.width, height: dimensions.height } : {};

  if (!payload?.imageUrl) return null;

  const content = (
    <img 
      src={payload.imageUrl} 
      alt={payload.alt || 'Advertisement'} 
      onLoad={event => {
        const image = event.currentTarget;
        if (!image.naturalWidth || (dimensions && (image.naturalWidth !== dimensions.width || image.naturalHeight !== dimensions.height))) { onFailure?.(); return; }
        onRenderState?.(true);
      }}
      onError={() => onFailure?.()}
      style={{ ...style, display: 'block', marginInline: 'auto', maxWidth: '100%', height: 'auto', flexShrink: 0 }}
    />
  );

  if (payload.clickUrl) {
    return (
      <a href={payload.clickUrl} target="_blank" rel="noopener noreferrer nofollow" style={{ display: 'block', width: dimensions?.width || 'auto', maxWidth: '100%', minWidth: 0, marginInline: 'auto' }}>
        {content}
      </a>
    );
  }

  return content;
};

export default ImageAdRenderer;
